// extracted by mini-css-extract-plugin
module.exports = {"nav":"_1lFHinwh6a48hEzncp-KPM","logo":"_2b1L1aenJrW7VxkQCeO5u8","navbar":"_2MO52xVlLy2qfsVMLawyO5"};